import { useEffect, useState } from "react";
import { Smartphone, CheckCheck } from "lucide-react";
import api from "../lib/api";
import { FadeUp } from "../components/Reveal";

export default function PortalNotifications() {
  const [items, setItems] = useState([]);

  const load = () => api.get("/notifications/mine").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const markAll = async () => {
    await api.post("/notifications/read-all");
    load();
  };

  return (
    <div className="max-w-2xl" data-testid="portal-notifications">
      <FadeUp className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h1 className="font-serif text-3xl sm:text-4xl text-obsidian">Text <span className="italic text-purple-700">updates</span></h1>
          <p className="text-sm text-slate-500 mt-2 flex items-center gap-2">
            <Smartphone size={14} className="text-gold" /> Confirmations are texted to the number on your profile — and every one also lives here.
          </p>
        </div>
        <button onClick={markAll} data-testid="mark-all-read-btn" className="flex items-center gap-2 text-xs text-purple-700 hover:text-gold transition-colors">
          <CheckCheck size={14} /> Mark all read
        </button>
      </FadeUp>

      <FadeUp delay={0.1} className="mt-10 bg-obsidian rounded-[2.5rem] p-3 shadow-2xl grain relative">
        <div className="bg-[#18171E] rounded-[2rem] p-5 min-h-[400px]">
          <p className="text-center text-[10px] font-mono uppercase tracking-[0.3em] text-white/30 py-2">Mixed By Empress · Text Message</p>
          <div className="space-y-4 mt-3">
            {items.map((n) => (
              <div key={n.notification_id} className="flex flex-col items-start" data-testid={`notification-${n.notification_id}`}>
                <div className={`max-w-[85%] rounded-2xl rounded-bl-sm px-4 py-3 text-sm leading-relaxed ${n.read ? "bg-white/10 text-white/70" : "bg-white/15 text-white border border-gold/30"}`}>
                  {n.message}
                </div>
                <span className="text-[10px] font-mono text-white/30 mt-1.5 ml-1">
                  {new Date(n.created_at).toLocaleString()} · {n.channel === "sms" ? `Texted to ${n.phone}` : n.sms_status === "failed" ? "Text failed — shown here" : "Portal notification"}
                </span>
              </div>
            ))}
            {items.length === 0 && <p className="text-sm text-white/40 italic text-center pt-24">No texts yet.</p>}
          </div>
        </div>
      </FadeUp>
    </div>
  );
}
